module.exports = __webpack_public_path__ + "img/img-not-found.fae3c9c9.svg";